import { createContext, useContext } from "react";
import type { AuthUser } from "./types";

const AuthContext = createContext<AuthUser | null>(null);

export const AuthProvider = AuthContext.Provider;

export function useAuthUser(): AuthUser | null {
  return useContext(AuthContext);
}
